
import { createStore } from 'vuex'

import app from './modules/app'
import modals from './modules/modals'
import user from './modules/user'
import cart from './modules/cart'
import staticPages from './modules/staticPages'
// import discount from './modules/discount'


const debug = process.env.NODE_ENV !== 'production'

const store = createStore({
    modules: {
        app,
        modals,
        user,
        cart,
        staticPages,
        // discount
    },
    strict: debug,
})

export default store